export default "__VITE_ASSET__CVNKud_k__"